import type { AxiosResponse } from 'axios';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  email: string;
  otp: number;
}

export interface VerifyOtpSuccessData {
  success: boolean;
  message: string;
  email: string;
  is_verified: boolean;
}

export interface VerifyOtpApiResponse {
  error: boolean;
  data: VerifyOtpSuccessData;
}

const postOtpVerifyMutation = async (values: Payload) => {
  const response = await axios.post('/auth/otp-verify', values);
  return response;
};

const registerOTPVerificationMutation = async (
  values: Payload
): Promise<AxiosResponse<VerifyOtpApiResponse>> => {
  const response = await axios.post<VerifyOtpApiResponse>(
    '/cleaners/email/verify-otp',
    values
  );
  return response;
};

export const usePostOtpVerifyMutation = () => {
  return useMutation({
    mutationKey: ['otp-verify'],
    mutationFn: postOtpVerifyMutation,
  });
};

export const useRegisterOTPVerificationMutation = () => {
  return useMutation({
    mutationKey: ['register-otp-verification'],
    mutationFn: registerOTPVerificationMutation,
  });
};
